import { render, staticRenderFns } from "./AdvisorDashboard_old.vue?vue&type=template&id=efb8af90&scoped=true"
import script from "./AdvisorDashboard_old.vue?vue&type=script&lang=js"
export * from "./AdvisorDashboard_old.vue?vue&type=script&lang=js"
import style0 from "./AdvisorDashboard_old.vue?vue&type=style&index=0&id=efb8af90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb8af90",
  null
  
)

export default component.exports